import { BaseTextFieldBox } from "@/shared/components/text-box/base-text-box";
import React, { useState } from "react";
import { useInputValidation, ValidationRule } from "@/shared/hooks/use-input-validation";

interface Props {
  onChange: (newValue: string) => void;
  id?: string;
  className?: string;
  title?: string;
  initialValue?: string;
  placeholder?: string;
  errorMessage?: string;
  nextFocusElementId?: string; // 次にフォーカスしたい要素のID
  isDisabled?: boolean;
  isReadOnly?: boolean;
  labelable?: boolean; // タイトルを表示するかどうか
  validationRule?: ValidationRule; // 入力値の検証ルール
  maxLength?: number; // 入力値の最大長さ
  // ブラウザ/パスワードマネージャーの自動入力制御。
  // デフォルトは "new-password"（自動入力させない）。ログイン画面のみ "current-password" を指定する。
  autoComplete?: string;
}

export const PasswordForm = (props: Props) => {
  const {
    onChange,
    id = "",
    className="",
    title = "パスワード",
    initialValue = "",
    placeholder = "半角英数字8～15文字",
    errorMessage = "",
    nextFocusElementId = "",
    isDisabled = false,
    isReadOnly = false,
    labelable = true,
    validationRule = "halfWidthAlnum",
    maxLength = 15,
    autoComplete = "new-password",
  } = props;

  const { validate } = useInputValidation(validationRule);

  // パスワード
  const [value, setValue] = useState(() => validate(initialValue ?? "", false));

  // パスワード表示制御フラグ
  const [isRevealPassword, setIsRevealPassword] = useState(false);

  // IME入力中フラグ
  const [isComposing, setIsComposing] = useState(false);

  // パスワード表示制御フラグ変更
  const onClickIsRevealPassword = () => {
   setIsRevealPassword(!isRevealPassword);
  };

  // 入力値の検証・反映
  const applyInputValue = (rawValue: string, composing: boolean) => {
    const newValue = validate(rawValue, composing);
    setValue(newValue);
    onChange(newValue);
  };

  // パスワード更新
  const onChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    applyInputValue(e.target.value, isComposing);
  };

  // IME確定時に検証ルールを適用
  const handleCompositionEnd = () => {
    setIsComposing(false);
    applyInputValue(value, false);
  };

  // キーボード入力イベント
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      if (nextFocusElementId) {
        doFocus(nextFocusElementId);
      }
    }
  };
  
  // フォーカスする
  const doFocus = (id: string) => {
    document.getElementById(id)?.focus();
  };

  return (
    <div 
      className="pass_wap"
      onKeyDown={onKeyDown}>
      <BaseTextFieldBox
        {...(id ? {id: id} : {})}
        className={className}
        title={title}
        placeholder={placeholder}
        value={value}
        type={isRevealPassword ? "text" : "password"}
        onChange={onChangePassword}
        onCompositionStart={() => setIsComposing(true)}
        onCompositionEnd={handleCompositionEnd}
        errorMessage={errorMessage}
        labelEnable={labelable}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        maxLength={maxLength}
        autoComplete={autoComplete}
      />
      {/* ボタンにonClickイベントを追加し、テキストを動的に変更 */}
        <button 
          type="button" 
          className="toggle_dsp" 
          data-target={id}
          onClick={onClickIsRevealPassword}
          style={labelable ? {top: "1.4rem"} : {}}
        >
          {isRevealPassword ? "非表示" : "表示"}
        </button>
    </div>
  );
};
